module.exports = __webpack_public_path__ + "static/media/rectangle@3x.193e3137.png";